import * as React from 'react';
import { LabeledInput } from '../LabeledInput';
import { IBModelInputProps } from './ModelInput.types';
import { onModelInputChange } from './ModelInput.logic';

const ModelInput: React.FC<IBModelInputProps> = (props: IBModelInputProps) => {
  const {
    propName,
    model,
    onChange,
    type,
    label,
    errorMessage,
    error,
    className,
    disabled,
    placeholder,
    id
  } = props;
  const handleOnChange = (e: string) =>
    onModelInputChange(e, onChange, model, propName);
  return (
    <LabeledInput
      id={id}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      label={label}
      error={error}
      errorMessage={errorMessage}
      value={(model && model[propName]) ?? ''}
      type={type ?? 'text'}
      onChange={handleOnChange}
    />
  );
};

export default ModelInput;
